let tokenProvider = async () => null;

export function setTokenProvider(fn) {
  tokenProvider = typeof fn === "function" ? fn : async () => null;
}

export async function getAccessToken() {
  const token = await tokenProvider();
  return token || null;
}
